module.exports = __webpack_public_path__ + "static/media/14UNEP25.3a12f708.jpg";